// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-container[data-v-4286a42f]{position:relative}.section-container[data-v-4286a42f]:after{content:\"\";width:100%;position:absolute;bottom:35px;background:#000;height:1px}.text-col[data-v-4286a42f]{max-width:400px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
